async function bootstrapLazy(lazyPromise, root, config) {
  return (await lazyPromise).default(root, config)
}

window.nn.registerModule('psdl-eherkenning-login', function (root, config) {
  return bootstrapLazy(import(/* webpackChunkName: "psdl-eherkenning-login" */ './bootstrapLoginEherkenning'), root, config);
});
